import { booleanAttribute } from "#ce/utils/props";

export const props = Object.freeze({
  /**
   * URL of the image to load. When the load fails, the component swaps to a placeholder SVG.
   *
   * @type {String}
   */
  src: {
    type: String,
    required: true,
  },
  /**
   * Alt text rendered on the <img> element and on the placeholder's <title> for accessibility.
   *
   * @type {String}
   * @default ""
   */
  alt: {
    type: String,
    default: "",
  },
  /**
   * Candidate image URLs for responsive image selection.
   *
   * @type {String}
   * @default undefined
   */
  srcset: {
    type: String,
    default: undefined,
  },
  /**
   * Display sizes used with `srcset` for responsive image selection.
   *
   * @type {String}
   * @default undefined
   */
  sizes: {
    type: String,
    default: undefined,
  },
  /**
   * Browser loading behaviour. "lazy" defers loading until the image is near the viewport; "eager" loads immediately.
   *
   * @type {String}
   * @default undefined
   * @values lazy, eager
   * @storybook-control radio
   */
  loading: {
    type: String,
    default: undefined,
    validator: (value) => [undefined, "lazy", "eager"].includes(value),
  },
  /**
   * Keep the browser's native broken-image state when the image cannot load.
   *
   * @type {Boolean|String}
   * @default false
   */
  noPlaceholder: booleanAttribute(),
  /**
   * Background fill colour of the placeholder SVG. Overrides --sp-comp-img-placeholder-background.
   *
   * @type {String}
   * @default "var(--sp-sys-color-outline-variant)"
   */
  placeholderbackground: {
    type: String,
    default: "var(--sp-sys-color-outline-variant)",
  },
  /**
   * Foreground fill colour of the placeholder SVG (the camera glyph). Overrides
   * --sp-comp-img-placeholder-color.
   *
   * @type {String}
   * @default "var(--sp-sys-color-outline)"
   */
  placeholdercolor: {
    type: String,
    default: "var(--sp-sys-color-outline)",
  },
});
